<template>
    <div class="memberList">
        <div class="query">
            <div>
                <el-input
                    style="width: 100px;"
                    placeholder="姓名"
                    clearable
                    size="mini"
                    @keyup.enter.native="findMemberPageList"
                    v-model="queryParam.name"
                    prefix-icon="el-icon-user"
                ></el-input>
                <el-input
                    style="width: 120px;"
                    placeholder="手机号码"
                    clearable
                    size="mini"
                    @keyup.enter.native="findMemberPageList"
                    v-model="queryParam.phone"
                    prefix-icon="el-icon-mobile-phone"
                ></el-input>
                <el-button
                    type="primary"
                    circle
                    plain
                    size="mini"
                    @click="findMemberPageList"
                    icon="el-icon-search"
                ></el-button>
            </div>
        </div>
        <br />
        <el-table
            :data="tableData"
            style="width: 100%"
        >
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="手机号码"></el-table-column>
            <el-table-column
                label="操作"
                width="50">
                <template slot-scope="scope">
                    <el-link
                    @click.native.prevent="checkRow(scope.$index, tableData)"
                    v-if="validateMember(scope.$index, tableData)"
                    type="primary"
                    :underline="false">
                    添加
                    </el-link>
                    <el-link
                    v-else
                    type="danger"
                    @click.native.prevent="unCheckRow(scope.$index, tableData)"
                    :underline="false">
                    取消
                    </el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <el-col :span="24" align="right">
                <el-pagination
                    small
                    class="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="paginations.page_index"
                    :page-size="paginations.page_size"
                    :layout="paginations.layout"
                    :total="paginations.total"
                ></el-pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { findMemberPageList } from "@/api/index";

export default {
    props: {
        memberList: Array
    },
    data() {
        return {
            queryParam: {
                name: "",
                phone: ""
            },
            tableData: [],
            paginations: {
                page_index: 1, //当前位于哪页
                total: 0, //总数
                page_size: 5, //每页显示多少条
                layout: "total, prev, pager, next"
            }
        };
    },
    methods: {
        findMemberPageList() {
            let that = this;
            findMemberPageList({
                name: this.queryParam.name,
                phone: this.queryParam.phone,
                pageIndex: this.paginations.page_index,
                size: this.paginations.page_size
            }).then(res => {
                if (res.success == true) {
                    that.tableData = res.result.list;
                    this.paginations.total = res.result.total;
                } else {
                    this.$notify.error({
                        title: "错误",
                        message: res.message
                    });
                }
            });
        },
        handleSizeChange(val) {
            this.paginations.page_size = val;
            this.findMemberPageList();
        },
        handleCurrentChange(val) {
            this.paginations.page_index = val;
            this.findMemberPageList();
        },
        genderFormatter(row, column) {
            return row.gender == "1" ? "男" : "女";
        },
        checkRow(index, rows) {
            this.$emit("selectMember", rows[index])
        },
        unCheckRow(index, rows) {
            this.$emit("unSelectMember", rows[index])
        },
        validateMember(index, rows){
            let member = rows[index]
            var index = this.memberList.findIndex(item => item.id === member.id)
            if (index > -1) {
                return false
            } else {
                return true
            }
        }
    },
    created() {
        this.findMemberPageList();
    }
};
</script>

<style lang="scss">
.memberList {
    margin: 0px;
    height: 300px;

    .query {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
}
</style>